module.exports = __webpack_public_path__ + "img/tag_blank_center.6da386fd.svg";